import React from "react";
import styled from "styled-components/macro";
import { ProductCartItem } from "./types";
import climaIMG from "../../assets/images/clima_img.png";
import { DefaultText, noSelect } from "theme/GlobalElements";
import { toRem } from "theme/Breakpoints";
import { colors } from "theme/Theme";
import { FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ProductImage } from "features/ProductReel/types";
import DualPrice from "components/Price";
interface Props {
  item: ProductCartItem;
  removeElemenWithId?: (el: string) => void;
}

const SampleProductCard: React.FC<Props> = ({ item, removeElemenWithId }) => {
  const navigate = useNavigate();
  const price = item.product?.price_promotion
    ? item.product.price_promotion
    : item.product.price
    ? item.product.price
    : 0;
  const priceEur = item.product?.price_promotion
    ? item.product.price_promotion_eur
    : item.product.price_eur;
  const removeElement = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    removeElemenWithId && removeElemenWithId(item.product._id);
  };

  const goTo = () => {
    navigate(`/product/${encodeURIComponent(item.product.alias)}`);
  };

  return (
    <ElementContainer>
      {!item.product.image && item.product.images.length === 0 && <Image src={climaIMG} />}
      {item.product.images && !Array.isArray(item.product.images) && (
        <Image
          alt={item.product.images.alt ?? ""}
          src={`data:${item.product.images.contentType};base64,${item.product.images.image}`}
        />
      )}
      {item.product.images && Array.isArray(item.product.images) && (
        <Image
          alt={item.product.images[0].alt ?? ""}
          src={`data:${item.product.images[0].contentType};base64,${item.product.images[0].image}`}
        />
      )}
      {item.product.image && (
        <Image
          alt={item.product.image.alt ?? ""}
          src={`data:${item.product.image.contentType};base64,${item.product.image.image}`}
        />
      )}
      <Description>
        <Title className="text-sm" onClick={goTo}>
          {item.product?.title}
        </Title>
        <Information>
          {item.count && <DefaultText fontSize={12}>{`${item.count}x`}</DefaultText>}
          <DefaultText fontSize={14} color="blue">
            <DualPrice bgn={price} eur={priceEur} />
          </DefaultText>
        </Information>
      </Description>
      {removeElemenWithId && (
        <RemoveItem onClick={removeElement}>
          <FaTrash className="filter-remove" />
        </RemoveItem>
      )}
    </ElementContainer>
  );
};

const ElementContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  /* width: ${toRem(350)}; */
  width: auto;
  height: ${toRem(70)};
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #eaeaea;
  .delete {
    min-width: 1rem;
    align-self: normal;
    &:hover {
      color: red;
    }
  }
`;
const Image = styled.img`
  width: ${toRem(80)};
  min-width: ${toRem(80)};
  height: 100%;
  object-fit: contain;
  ${noSelect};
`;
const Description = styled.div`
  cursor: pointer;
  align-self: flex-start;
  padding-left: 5px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
`;

const Title = styled.div`
  line-height: 1.5em;
  height: 3em; /* height is 2x line-height, so two lines will display */
  overflow: hidden;
  ${noSelect};
  width: 90%;
  align-self: flex-start;
  text-align: left;
`;
const Information = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: baseline;
`;

const RemoveItem = styled.div`
  position: absolute;
  top: 3px;
  right: 3px;

  .filter-remove {
    width: 18px;
    height: 18px;
    fill: ${colors.dark_gray};
  }
`;

export default SampleProductCard;
